// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,\nhtml {\n   width: 100%;\n   height: 100%;\n   margin: 0;\n   padding: 0;\n   border: 0;\n   font-size: 100%;\n}\n\n:root {\n   --reach-dialog: 1;\n   --reach-tooltip: 1;\n   --reach-tabs: 1;\n   --reach-checkbox: 1;\n}\n", ""]);
// Exports
module.exports = exports;
